import Keycloak from 'keycloak-js';

const url = import.meta.env.VITE_APP_KEYCLOAK_URL;
const clientId = import.meta.env.VITE_APP_KEYCLOAK_CLIENT_ID;
const realm = import.meta.env.VITE_APP_KEYCLOAK_REALM;

const keycloakConfig = { url, realm, clientId, enableCors: true };

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
